export enum PositionType {
  Purchase = 17,
  Sale = 18,
  Multiposition = 99
}
